document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('[data-pawspin]');
  if (!section) return;

  const form = section.querySelector('.pawspin__form');
  const pricing = section.querySelector('[data-pawspin-pricing]');
  const quantityInput = form.querySelector('[data-pawspin-quantity]');
  let pendingEasySellQuantity = '1';

  window.ES_VARIANT_SELECTOR_OVERRIDE = '[data-pawspin-offer]:checked';

  const styleEasySellButton = () => {
    document.querySelectorAll('#es-form-button, #es-popup-button, .es-popup-button-product, .es-popup-button-product button').forEach((button) => {
      button.style.setProperty('background', '#35233d', 'important');
      button.style.setProperty('background-color', '#35233d', 'important');
      button.style.setProperty('border-color', '#35233d', 'important');
      button.style.setProperty('color', '#ffffff', 'important');
    });
  };

  const syncEasySellQuantityOffer = () => {
    const expectedTitle = pendingEasySellQuantity === '2' ? '2 PawSpins' : '1 Unit';
    const target = [...document.querySelectorAll('.es-qo-container')].find((container) => {
      const title = container.querySelector('.offer-title, .mb-1');
      return title && title.textContent.trim() === expectedTitle;
    });
    if (target) target.click();
  };

  styleEasySellButton();
  document.addEventListener('click', (event) => {
    if (!event.target.closest('#es-popup-button, .es-popup-button, .es-popup-button-product')) return;
    [150, 450, 900, 1500, 2400].forEach((delay) => window.setTimeout(() => {
      styleEasySellButton();
      syncEasySellQuantityOffer();
    }, delay));
  }, true);

  section.querySelectorAll('[data-pawspin-offer]').forEach((offer) => {
    offer.addEventListener('change', () => {
      if (!offer.checked) return;
      pendingEasySellQuantity = offer.dataset.quantity || '1';
      quantityInput.value = pendingEasySellQuantity;
      section.querySelectorAll('.pawspin__offer-choice').forEach((choice) => choice.classList.toggle('is-selected', choice.contains(offer)));
      pricing.querySelector('[data-pawspin-current-price]').textContent = offer.dataset.price;
      const comparePrice = pricing.querySelector('[data-pawspin-compare-price]');
      const discount = pricing.querySelector('[data-pawspin-discount]');
      comparePrice.textContent = offer.dataset.comparePrice;
      discount.textContent = offer.dataset.discount;
      comparePrice.hidden = !offer.dataset.comparePrice;
      discount.hidden = !offer.dataset.discount;
      pricing.querySelector('[data-pawspin-saving-copy]').textContent = offer.dataset.saving;
    });
  });
});
